<template>
  <div id="app" >
    <nav-bar-vue/>
    <router-view/>
    <!-- ========================= scroll-top ========================= -->
    <a href="" class="scroll-top btn-hover">
        <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import NavBarVue from './components/NavBar.vue';

export default {
  components: {
  NavBarVue 
  },
  
};
</script>

<style>
</style>
